import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "شرکت کنندگان ")
  ])
], -1)
const _hoisted_5 = {
  class: "card-body",
  "element-loading-text": "درحال بارگزاری ..."
}
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "symbol symbol-40px flex-shrink-0 me-2" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "ml-4" }
const _hoisted_13 = { class: "text-dark-75 font-weight-bolder font-size-lg mb-0" }
const _hoisted_14 = { class: "text-muted small font-weight-bold text-hover-primary" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye fs-5" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col-md-8" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-800 w-bolder mb-4" }, "نمایش گروهی پاسخ ها", -1)
const _hoisted_23 = ["data-bs-target"]
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"btn btn-sm btn-icon mw-20px btn-active-color-primary me-5\"><span class=\"svg-icon toggle-on svg-icon-primary svg-icon-1\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect opacity=\"0.3\" x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\" fill=\"currentColor\"></rect><rect x=\"6.0104\" y=\"10.9247\" width=\"12\" height=\"2\" rx=\"1\" fill=\"currentColor\"></rect></svg></span><span class=\"svg-icon toggle-off svg-icon-1\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect opacity=\"0.3\" x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\" fill=\"currentColor\"></rect><rect x=\"10.8891\" y=\"17.8033\" width=\"12\" height=\"2\" rx=\"1\" transform=\"rotate(-90 10.8891 17.8033)\" fill=\"currentColor\"></rect><rect x=\"6.01041\" y=\"10.9247\" width=\"12\" height=\"2\" rx=\"1\" fill=\"currentColor\"></rect></svg></span></div>", 1)
const _hoisted_25 = { class: "text-gray-700 cursor-pointer mb-0" }
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "mb-4 text-gray-600 fw-semibold fs-6 ps-10" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "ml-4" }
const _hoisted_32 = { class: "font-size-lg mb-0" }
const _hoisted_33 = { class: "px-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fs-7" }, "پاسخ :", -1)
const _hoisted_35 = { class: "px-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Date = _resolveComponent("Date")!
  const _component_Notice = _resolveComponent("Notice")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ShowUserQuestionAnswer = _resolveComponent("ShowUserQuestionAnswer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_8, [
                        _createElementVNode("span", null, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("img", {
                                class: "",
                                src: item.chat.avatar,
                                alt: "photo"
                              }, null, 8, _hoisted_11)
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(item.chat.name), 1),
                              _createElementVNode("span", _hoisted_14, [
                                _createVNode(_component_Date, {
                                  date: item.chat.created_at
                                }, null, 8, ["date"])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_15, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.activeSessionKey = item.key),
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#kt_modal_show_user_answer_question_body",
                          class: "btn btn-sm btn-outline btn-outline-dashed btn-active-light-info me-1 mb-1"
                        }, _hoisted_18, 8, _hoisted_16)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_ctx.list && _ctx.list.length === 0)
              ? (_openBlock(), _createBlock(_component_Notice, {
                  key: 0,
                  classes: "rounded-3",
                  color: "info",
                  title: "توجه کنید !",
                  body: "تاکنون پاسخی ارسال نشده است."
                }))
              : _createCommentVNode("", true)
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          (_ctx.pagination && _ctx.pagination.total_pages > 1)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                background: "",
                layout: "prev, pager, next",
                class: "mt-4 mb-4 text-center direction-rtl",
                total: _ctx.pagination.total,
                currentPage: _ctx.pagination.current_page,
                "page-size": _ctx.pagination.per_page,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["total", "currentPage", "page-size", "onSizeChange", "onCurrentChange"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listAnswers, (answers, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "m-0",
                key: index
              }, [
                _createElementVNode("div", {
                  class: "d-flex align-items-center collapsible py-3 toggle mb-0",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": `#kt_job_6_${index}`
                }, [
                  _hoisted_24,
                  _createElementVNode("h4", _hoisted_25, _toDisplayString(answers.question.text), 1)
                ], 8, _hoisted_23),
                _createElementVNode("div", {
                  id: `kt_job_6_${index}`,
                  class: _normalizeClass(["collapse fs-6 ms-1", index === 0 ? 'show' : ''])
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answers.answers, (item, indexAnswer) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: indexAnswer,
                        class: "shadow-sm rounded w-100 p-2 mb-2"
                      }, [
                        _createElementVNode("span", null, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", {
                              class: "symbol symbol-40px flex-shrink-0 me-2",
                              onClick: ($event: any) => (_ctx.activeSessionKey = item.chat.session_key),
                              type: "button",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#kt_modal_show_user_answer_question_body"
                            }, [
                              _createElementVNode("img", {
                                class: "",
                                src: item.chat.avatar,
                                alt: "photo"
                              }, null, 8, _hoisted_30)
                            ], 8, _hoisted_29),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, _toDisplayString(item.chat.name), 1),
                              _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("span", _hoisted_35, _toDisplayString(item.answer), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ], 10, _hoisted_26),
                _hoisted_36
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_ShowUserQuestionAnswer, { session_key: _ctx.activeSessionKey }, null, 8, ["session_key"])
  ], 64))
}